import React from 'react';

import Container from '../../interface/Container';
import BlockWrapper from '../BlockWrapper';
import { CtaButton, Title } from './Text.styles';

const TextBlock = ({ block }) => {
  const { mainTitle, text, linkTitle, ctaUrl } = block;

  return (
    <BlockWrapper>
      <Container size="small">
        {mainTitle && <Title>{mainTitle}</Title>}
        <div dangerouslySetInnerHTML={{ __html: text }} />
        {linkTitle && ctaUrl && (
          <CtaButton href={ctaUrl.url} type={ctaUrl.type} size="large">
            {linkTitle}
          </CtaButton>
        )}
      </Container>
    </BlockWrapper>
  );
};

export default TextBlock;
